import { v4 as uuidv4 } from 'uuid';

export function ModalHeader(props, childrenComponents = []) {
	return {
		componentName: 'ModalHeader',
		componentId: uuidv4(),
		props: Object.assign(
			{
				showCloseButton: true,
				iconCloseSize: 32,
			},
			props,
		),
		childrenComponents,
	};
}
